export default {
  init() {
    go();
		window.addEventListener('resize', go);
		function go(){
		  if(document.documentElement.clientWidth <= 649) {
		  	setTimeout(function(){
		  		$(".favorites-list li").slice(0,3).show();
				  $("#seeMore").click(function(e){
				    e.preventDefault();
				    $(".favorites-list li:hidden").slice(0,3).fadeIn("slow");
				    
				    if($(".favorites-list li:hidden").length == 0){
				      $("#seeMore").fadeOut("slow");
				    }
				  });
		  	},1500);
		  }
		}

		jQuery('.simplefavorite-button.active').click(function(){
  		$(this).parents('.each_part_car').remove();
  		var test = parseInt($('.count_favorites_result').html());
  		$('.count_favorites_result').html(test-=1);
    });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/favorites.js